import ProcessModel from "./ProcessModel"

export default ProcessModel;
